module.exports = __webpack_public_path__ + "img/sally-logo-icon.49108b5a.svg";